// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + ({"2931":"save_log","4362":"report_log","7204":"encryption"}[chunkId] || chunkId) + ".1793803691363.js");